<template lang="">
  <v-container
    v-if="
      user.permissions.indexOf(permissionsAll.rol_update) >= 0 ||
        user.person.types_person.id === 3
    "
  >
    <BreadCrumbsVue :items="itemsBreadCrumbs" />
    <FormRol :actionForm="actionForm" @sendForm="sendForm" />
  </v-container>
</template>
<script>
import { beginRequest, endRequest, itemsBreadCrumbs } from "../../helpers";
import BreadCrumbsVue from "../../components/_commons/BreadCrumbs.vue";
import FormRol from "../../components/roles/FormRol.vue";
import { mapState } from "vuex";
import permissions from "../../helpers/permissions";
export default {
  name: "UserCreate",
  components: {
    BreadCrumbsVue,
    FormRol,
  },
  data() {
    return {
      itemsBreadCrumbs: itemsBreadCrumbs.rolesUpdate,
      actionForm: "Edit",
      permissionsAll: permissions,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    async sendForm(formData) {
      await beginRequest();
      const payload = {
        id: this.$route.params.idrol,
        data: formData,
      };
      const { snack, status } = await this.$store.dispatch(
        "updateRol",
        payload
      );
      await endRequest(snack, status);
    },
  },
};
</script>
